import React, { useEffect, useState } from "react";
import { Container, Card, Spinner, Alert } from "react-bootstrap";
import { eventAccessApi } from "../Components/eventAccessApi";
import QRCodeCard from "../Components/QRCodeCard";
import SideBar from "../Components/SideBar";

export default function EventAccessStudent() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await eventAccessApi.myCode();
        if (res?.error && !cancelled) {
          setError(res.error);
          setData(null);
          return;
        }
        if (!cancelled) {
          setData({
            event: res?.event ?? null,
            qrCodeUrl: res?.qr_code_url ?? null,
            expiresAt: res?.expires_at ?? null,
            isUsed: res?.is_used ?? false,
          });
        }
      } catch (e) {
        if (!cancelled) {
          setError(e?.message || "Failed to load your QR code");
          setData(null);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, []);

  return (
    <Container fluid className="p-0">
      <div className="d-flex">
        <div className="sidebar-column" style={{ minWidth: 220 }}>
          <SideBar />
        </div>
        <div className="flex-grow-1 p-4">
          <h4 className="mb-4">Event Access – Your QR Code</h4>
          {loading && (
            <div className="text-center py-5">
              <Spinner animation="border" />
            </div>
          )}
          {error && (
            <Alert variant="danger" dismissible onClose={() => setError(null)}>
              {error}
            </Alert>
          )}
          {!loading && !error && data && (
            <div className="d-flex justify-content-center">
              <div style={{ maxWidth: 320 }}>
                <QRCodeCard
                  qrCodeUrl={data.qrCodeUrl}
                  event={data.event}
                  expiresAt={data.expiresAt}
                  isUsed={data.isUsed}
                />
                {!data.event && !data.qrCodeUrl && (
                  <p className="text-muted text-center mt-2 small">
                    You don’t have an event QR code yet. Register for an event to receive one.
                  </p>
                )}
              </div>
            </div>
          )}
        </div>
      </div>
    </Container>
  );
}
